import { apiClient } from "../client";
import { StandardAxiosConfig } from "../common";
import { MissionControlLog } from "@domain/missionControl";
import { env } from "../../config/env";
export class MissionControlAPI {
	private baseUrl: string;

	constructor() {
		this.baseUrl = `${env.rogoApiUrl}/mission-control`;
	}

	public async getLogs(user: string, start: string, end: string): Promise<MissionControlLog[]> {
		const url = `${this.baseUrl}/logs`;
		const response = await apiClient.get(url, {
			...StandardAxiosConfig(),
			params: { user, start, end },
		});
		return response.data as MissionControlLog[];
	}
}
